module.exports = __webpack_public_path__ + "img/ico_cart_all.e9c7153a.png";